var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdownCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13350_66303)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.7656 4.51358L8.27344 12.0473L6 9.76889L13.5034 2.23764C13.5771 2.16333 13.6647 2.10427 13.7613 2.06383C13.8578 2.02339 13.9613 2.00237 14.066 2.00196C14.1706 2.00155 14.2743 2.02177 14.3712 2.06146C14.468 2.10115 14.5561 2.15953 14.6303 2.23326L14.6347 2.23764L15.7656 3.37545C15.9157 3.52681 16 3.73134 16 3.94451C16 4.15768 15.9157 4.36222 15.7656 4.51358Z",
    fill: "#2DB49E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27088 12.0496L6.56556 13.7643C6.41671 13.9143 6.21436 13.999 6.00303 13.9998C5.79171 14.0007 5.58871 13.9175 5.43869 13.7687L5.43431 13.7643L0.234314 8.53429C0.0841485 8.38302 -0.00012207 8.17852 -0.00012207 7.96538C-0.00012207 7.75224 0.0841485 7.54774 0.234314 7.39647L1.36556 6.25866C1.51418 6.10903 1.71607 6.02444 1.92697 6.02345C2.13786 6.02245 2.34054 6.10513 2.49056 6.25335L2.49556 6.25866L8.27088 12.0496Z",
    fill: "#2DB49E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13350_66303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownCheck);
export default __webpack_public_path__ + "static/media/dropdown-check.90044fa1.svg";
export { ForwardRef as ReactComponent };